import React, { useState } from 'react';
import { Wifi, Luggage, Bike } from 'lucide-react';
import './Timetables.css';

const Timetables = () => {
  const [selectedRoute, setSelectedRoute] = useState('libertarian');

  // Format time from 24h to 12h with A/P suffix
  const formatTime = (time24) => {
    const [hours, minutes] = time24.split(':').map(Number);
    const suffix = hours >= 12 ? 'P' : 'A';
    const displayHours = hours > 12 ? hours - 12 : (hours === 0 ? 12 : hours);
    return `${displayHours}${minutes.toString().padStart(2, '0')}${suffix}`;
  };

  const timetables = {
    libertarian: {
      name: 'Libertarian',
      color: '#fbbf24',
      direction: 'SOUTHBOUND / NORTHBOUND',
      route: 'KingsPort - Petersburg - Washington DC - Baltimore - Philadelphia - Trenton - Newark - New York',
      trains: [
        {
          number: 'P295',
          direction: 'Southbound',
          days: 'Daily',
          stations: [
            { name: 'KingsPort', time: '04:15' },
            { name: 'Danville', time: '05:22' },
            { name: 'South Boston', time: '05:48' },
            { name: 'Clarkesville', time: '06:12' },
            { name: 'South Hill', time: '06:35' },
            { name: 'Lawrenceville', time: '06:58' },
            { name: 'Emporia', time: '07:20' },
            { name: 'Petersburg', time: '08:10' },
            { name: 'Rich-Staple Mill Rd', time: '08:45' },
            { name: 'Ashland', time: '09:05' },
            { name: 'Fredericksburg', time: '10:15' },
            { name: 'Quantico', time: '11:02' },
            { name: 'Alexandria', time: '11:35' },
            { name: 'Washington DC Union', time: '12:00', major: true },
            { name: 'Baltimore', time: '12:45', major: true },
            { name: 'Wilmington', time: '13:50' },
            { name: 'Philadelphia', time: '14:30', major: true },
            { name: 'Trenton', time: '15:15' },
            { name: 'Metropark', time: '16:10' },
            { name: 'Newark Liberty', time: '16:45' },
            { name: 'Newark Penn St', time: '17:05', major: true },
            { name: 'New York Penn', time: '17:30', major: true, arrival: true }
          ]
        },
        {
          number: 'P301',
          direction: 'Northbound',
          days: 'Daily',
          stations: [
            { name: 'New York Penn', time: '06:25', major: true },
            { name: 'Newark Penn St', time: '06:50', major: true },
            { name: 'Newark Liberty', time: '07:05' },
            { name: 'Metropark', time: '07:20' },
            { name: 'Trenton', time: '07:50' },
            { name: 'Philadelphia', time: '08:25', major: true },
            { name: 'Wilmington', time: '09:00' },
            { name: 'Baltimore', time: '09:45', major: true },
            { name: 'Washington DC Union', time: '10:30', major: true },
            { name: 'Alexandria', time: '10:50' },
            { name: 'Quantico', time: '11:15' },
            { name: 'Fredericksburg', time: '11:45' },
            { name: 'Ashland', time: '12:30' },
            { name: 'Rich-Staple Mill Rd', time: '12:48' },
            { name: 'Petersburg', time: '13:05' },
            { name: 'Emporia', time: '13:38' },
            { name: 'Lawrenceville', time: '13:58' },
            { name: 'South Hill', time: '14:18' },
            { name: 'Clarkesville', time: '14:40' },
            { name: 'South Boston', time: '15:02' },
            { name: 'Danville', time: '15:25' },
            { name: 'KingsPort', time: '16:15', major: true, arrival: true }
          ]
        }
      ]
    },
    cruiser: {
      name: 'Cruiser',
      color: '#ffffff',
      direction: 'EASTBOUND / WESTBOUND',
      route: 'KingsPort - Emporia - Franklin - Suffolk - Portsmouth - Norfolk',
      trains: [
        {
          number: 'P058',
          direction: 'Eastbound',
          days: 'Daily',
          stations: [
            { name: 'KingsPort', time: '06:15', major: true },
            { name: 'Danville', time: '08:35' },
            { name: 'South Boston', time: '09:10' },
            { name: 'Clarkesville', time: '09:40' },
            { name: 'South Hill', time: '10:05' },
            { name: 'Lawrenceville', time: '10:30' },
            { name: 'Emporia', time: '10:55', major: true },
            { name: 'Franklin', time: '11:35' },
            { name: 'Suffolk', time: '12:15' },
            { name: 'Portsmouth', time: '13:05' },
            { name: 'Norfolk', time: '14:30', major: true, arrival: true }
          ]
        },
        {
          number: 'P158',
          direction: 'Westbound',
          days: 'Daily',
          stations: [
            { name: 'Norfolk', time: '05:30', major: true },
            { name: 'Portsmouth', time: '06:00' },
            { name: 'Suffolk', time: '06:30' },
            { name: 'Franklin', time: '07:05' },
            { name: 'Emporia', time: '07:50', major: true },
            { name: 'Lawrenceville', time: '08:15' },
            { name: 'South Hill', time: '08:38' },
            { name: 'Clarkesville', time: '09:00' },
            { name: 'South Boston', time: '09:22' },
            { name: 'Danville', time: '09:48' },
            { name: 'KingsPort', time: '10:58', major: true, arrival: true }
          ]
        }
      ]
    },
    southsidean: {
      name: 'Southsidean',
      color: '#a855f7',
      direction: 'SOUTHBOUND / NORTHBOUND',
      route: 'KingsPort - Rocky Mt - Fayetteville - Florence - Charleston - Savannah - Jacksonville - Orlando - Miami',
      trains: [
        {
          number: 'P117',
          direction: 'Southbound',
          days: 'Daily',
          stations: [
            { name: 'KingsPort', time: '03:20', major: true },
            { name: 'Danville', time: '05:40' },
            { name: 'Clarkesville', time: '07:50' },
            { name: 'South Hill', time: '09:10' },
            { name: 'Emporia', time: '10:35', major: true },
            { name: 'Rocky Mt, NC', time: '11:50', major: true },
            { name: 'Raleigh', time: '13:21' },
            { name: 'Cary', time: '13:38' },
            { name: 'Southern Pines', time: '14:44' },
            { name: 'Hamlet', time: '15:32' },
            { name: 'Camden', time: '16:47' },
            { name: 'Columbia', time: '17:42' },
            { name: 'Denmark', time: '18:49' },
            { name: 'Savannah, GA', time: '20:13', major: true },
            { name: 'Jacksonville, FL', time: '23:15', major: true },
            { name: 'Palatka', time: '00:21' },
            { name: 'DeLand', time: '01:08' },
            { name: 'WinterPark', time: '01:52' },
            { name: 'Orlando', time: '02:15', major: true },
            { name: 'Kissimmee', time: '02:45' },
            { name: 'Lakeland', time: '04:00' },
            { name: 'Tampa', time: '05:05' },
            { name: 'Lakeland', time: '06:17' },
            { name: 'Winter Haven', time: '07:02' },
            { name: 'Sebring', time: '07:40' },
            { name: 'Okeechobee', time: '08:24' },
            { name: 'West Palm Beach', time: '10:04', major: true },
            { name: 'Deerfield Beach', time: '10:41' },
            { name: 'Ft. Lauderdale', time: '11:01', major: true },
            { name: 'Hollywood', time: '11:16' },
            { name: 'Miami, FL', time: '17:59', major: true, arrival: true }
          ]
        },
        {
          number: 'P221',
          direction: 'Northbound',
          days: 'Daily',
          stations: [
            { name: 'KingsPort', time: '11:39', major: true, arrival: true },
            { name: 'Danville', time: '09:19' },
            { name: 'Clarkesville', time: '07:09' },
            { name: 'South Hill', time: '05:49' },
            { name: 'Emporia', time: '04:24', major: true },
            { name: 'Rocky Mt, NC', time: '03:09', major: true },
            { name: 'Raleigh', time: '01:38' },
            { name: 'Cary', time: '01:21' },
            { name: 'Southern Pines', time: '00:15' },
            { name: 'Hamlet', time: '23:27' },
            { name: 'Camden', time: '22:12' },
            { name: 'Columbia', time: '21:17' },
            { name: 'Denmark', time: '20:10' },
            { name: 'Savannah, GA', time: '18:46', major: true },
            { name: 'Jacksonville, FL', time: '15:44', major: true },
            { name: 'Palatka', time: '14:38' },
            { name: 'DeLand', time: '13:51' },
            { name: 'WinterPark', time: '13:07' },
            { name: 'Orlando', time: '12:44', major: true },
            { name: 'Kissimmee', time: '12:14' },
            { name: 'Lakeland', time: '10:59' },
            { name: 'Tampa', time: '09:54' },
            { name: 'Lakeland', time: '08:42' },
            { name: 'Winter Haven', time: '07:57' },
            { name: 'Sebring', time: '07:19' },
            { name: 'Okeechobee', time: '06:35' },
            { name: 'West Palm Beach', time: '05:02', major: true },
            { name: 'Deerfield Beach', time: '04:22' },
            { name: 'Ft. Lauderdale', time: '04:02', major: true },
            { name: 'Hollywood', time: '03:47' },
            { name: 'Miami, FL', time: '03:15', major: true }
          ]
        }
      ]
    }
  };

  const currentTimetable = timetables[selectedRoute];

  return (
    <div className="timetables-container">
      {/* Route Selector */}
      <div className="route-selector">
        <button
          className={`route-btn ${selectedRoute === 'libertarian' ? 'active' : ''}`}
          style={{ 
            backgroundColor: selectedRoute === 'libertarian' ? timetables.libertarian.color : '#374151',
            color: selectedRoute === 'libertarian' ? '#000' : '#fff'
          }}
          onClick={() => setSelectedRoute('libertarian')}
        >
          Libertarian
        </button>
        <button
          className={`route-btn ${selectedRoute === 'cruiser' ? 'active' : ''}`}
          style={{ 
            backgroundColor: selectedRoute === 'cruiser' ? timetables.cruiser.color : '#374151',
            color: selectedRoute === 'cruiser' ? '#000' : '#fff',
            border: selectedRoute === 'cruiser' ? '2px solid #000' : 'none'
          }}
          onClick={() => setSelectedRoute('cruiser')}
        >
          Cruiser
        </button>
        <button
          className={`route-btn ${selectedRoute === 'southsidean' ? 'active' : ''}`}
          style={{ 
            backgroundColor: selectedRoute === 'southsidean' ? timetables.southsidean.color : '#374151'
          }}
          onClick={() => setSelectedRoute('southsidean')}
        >
          Southsidean
        </button>
      </div>

      {/* Header */}
      <div className="timetable-header" style={{ 
        backgroundColor: currentTimetable.color,
        color: currentTimetable.name === 'Cruiser' ? '#000' : '#000'
      }}>
        <div className="header-content">
          <h1>{currentTimetable.name.toUpperCase()}</h1>
          <h2>{currentTimetable.direction}</h2>
          <p className="route-description">{currentTimetable.route}</p>
        </div>
        <div className="ag-western-logo">
          <span>AG&W</span>
          <small>RAIL</small>
        </div>
      </div>

      {/* Timetable Grid */}
      <div className="timetable-grid">
        <table>
          <thead>
            <tr>
              <th className="station-col">Station</th>
              {currentTimetable.trains.map(train => (
                <th key={train.number} style={{ 
                  backgroundColor: currentTimetable.color,
                  color: currentTimetable.name === 'Cruiser' ? '#000' : '#000'
                }}>
                  <div className="train-header">
                    <span className="train-name">{currentTimetable.name}</span>
                    <span className="train-number">{train.number}</span>
                    <span className="train-direction">{train.direction}</span>
                  </div>
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {currentTimetable.trains[0].stations.map((station, idx) => (
              <tr key={idx} className={station.major ? 'major-station' : ''}>
                <td className="station-name">
                  {station.major && <span className="major-dot">●</span>}
                  {station.name}
                </td>
                {currentTimetable.trains.map(train => {
                  const trainStation = train.stations[idx];
                  return (
                    <td key={train.number} className="time-cell">
                      {trainStation ? formatTime(trainStation.time) : '—'}
                    </td>
                  );
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Legend */}
      <div className="timetable-legend">
        <h3>On-Board Services</h3>
        <div className="services-grid">
          <div className="service-item">
            <Luggage size={24} />
            <span>Baggage Coach</span>
          </div>
          <div className="service-item">
            <Wifi size={24} />
            <span>Free WiFi Access</span>
          </div>
          <div className="service-item">
            <Bike size={24} />
            <span>Bike Access</span>
          </div>
          <div className="service-item">
            <span className="service-icon">♿</span>
            <span>Handicap Access</span>
          </div>
          <div className="service-item">
            <span className="service-letter">B</span>
            <span>Business Coach</span>
          </div>
          <div className="service-item">
            <span className="service-letter">Q</span>
            <span>Quiet Coach</span>
          </div>
        </div>
        <p className="legend-note">● Major Stations</p>
      </div>
    </div>
  );
};

export default Timetables;
